import { Component, input } from '@angular/core';

@Component({
    selector: 'app-loading-spinner',
    imports: [],
    templateUrl: './loading-spinner.component.html',
    styleUrl: './loading-spinner.component.css'
})
export class LoadingSpinnerComponent {
  readonly message = input<string>('Loading...');
}
